import { render } from "./TableCard.vue?vue&type=template&id=2127b0a3"
import script from "./TableCard.vue?vue&type=script&lang=js"
export * from "./TableCard.vue?vue&type=script&lang=js"

import "./TableCard.vue?vue&type=style&index=0&id=2127b0a3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__